    Drupal.behaviors.blockTrackingBehaviour = {
      attach: function (context, settings) {
        let block_info = once(
          "blockTracking",
          ".block-tracking-item",
          context
        );
        
        block_info.forEach((block) => {
          let block_item_id = block.dataset.blockId;

          if (block_item_id) {
            fetch("/api/block/statistic/add", {
              method: "POST",
              headers: { "Content-Type":"application/json", "Accept":"application/json" },
              body: JSON.stringify({ 
                data: { 
                  block_id: block_item_id, 
                  type: 'view' 
                } 
              }),
            });
          }
        });
      },
    };